import type { CarouselProps as AntdCarouselProps } from "antd";
import { Carousel as AntdCarousel } from "antd";
import type { CarouselRef } from "antd/es/carousel";
import { AntdIcon, Button, Flex } from "index";
import React, { forwardRef, useImperativeHandle, useRef } from "react";

export interface CarouselProps extends AntdCarouselProps {
  arrows?: boolean;
}
const Carousel = forwardRef<CarouselRef, CarouselProps>(
  ({ arrows, ...props }, ref) => {
    // Internal ref to the underlying AntdCarousel instance
    const internalRef = useRef<CarouselRef | null>(null);

    // Expose the AntdCarousel instance to parent via the forwarded ref
    useImperativeHandle(ref, () => internalRef.current as CarouselRef, []);

    return (
      <Flex align="center" justify="space-between">
        {arrows ? (
          <Button
            dataTestId="scui-carousel-left"
            icon={<AntdIcon.LeftOutlined />}
            onClick={() => internalRef.current?.prev()}
            size="small"
            type="link"
          />
        ) : null}
        <AntdCarousel {...props} ref={internalRef} />
        {arrows ? (
          <Button
            dataTestId="scui-carousel-right"
            icon={<AntdIcon.RightOutlined />}
            onClick={() => internalRef.current?.next()}
            size="small"
            type="link"
          />
        ) : null}
      </Flex>
    );
  }
);

export default Carousel;
